module.exports = __webpack_public_path__ + "static/media/warning.3422a9f3.png";